import clsx from 'clsx';
import { type FC } from 'react';
import useGetPopoverWrappedContent from 'src/components/popover-footer/hooks/useGetPopoverWrappedContent';

import { NoWidgetData } from '../NoWidgetData';
import { WidgetLoading } from '../widget-loading';
import styles from './style.module.scss';

type Props = {
  unit?: string;
  loading?: boolean;
  value?: string;
  onClick?: () => void;
  noClickthroughMessageContent?: string;
};

export const ValueWidgetCloudscape: FC<Props> = ({
  value,
  unit,
  loading,
  onClick,
  noClickthroughMessageContent,
}) => {
  const getContent = useGetPopoverWrappedContent(
    onClick,
    noClickthroughMessageContent
  );
  if (loading) {
    return <WidgetLoading />;
  }
  if (value === undefined) {
    return <NoWidgetData />;
  }

  return (
    <div className={'flex items-center flex-wrap justify-center h-full'}>
      {getContent(
        <div className={styles.widget}>
          <span
            data-testid={'tile-value'}
            onClick={onClick}
            className={clsx(styles.number, { [styles.clickable]: !!onClick })}
          >
            {value}
          </span>
          <span data-testid={'tile-unit'} className={styles.units}>
            {unit}
          </span>
        </div>
      )}
    </div>
  );
};
